import React from 'react';
import {
  NOT,
  YES
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import {
  ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS
} from '../../../lib/Definition';
import Employer from '../../../lib/Employer';
import {
  Obj
} from '../../../lib/Object.lib';
import {
  Str,
  compileText
} from '../../../lib/String.lib';
import {
  getParams
} from '../../../lib/URL.lib';
import useState from '../../../lib/hooks/useState.hook';
import getEmployerModel from '../../../lib/models/employer';
import {
  COLLECTION__EMPLOYERS, readLoopbackRecord,
  updateLoopbackRecord
} from '../../../lib/services/BE/loopback.api';
import Page from '../../Layout/Page';
import Card from '../../Layout/Wrappers/Card';
import Navigate from '../../Layout/Wrappers/Navigate';
import Once from '../../Layout/Wrappers/Once';
import SectionAtsSettings from './SectionAtsSettings';

export const EMPLOYER_SETTINGS__LABELS = {
  page: {
    title: '{{EMPLOYER__NAME}}  –  Manage ATS Integration'
  },
};

export default function PageEmployerSettings({
  acl = true,
  ...props
}) {
  const mem = React.useRef({});
  const [state, updateState] = useState();
  acl = (
    acl &&
    (
      Core.isEmployer() ||
      Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER_SETTINGS })
    )
  );
  if (NOT(acl)) { return <Navigate to='/' />; }
  const { employerId } = getParams({ pattern: '/employer/settings/:employerId' });
  const { employer = {} } = state;
  return (
    <Page showBack={false}
      title={
        compileText(EMPLOYER_SETTINGS__LABELS.page.title, {
          EMPLOYER__NAME: Str(employer.name)
        })
      }
    >
      <Card
        className='m-auto'
        style={{
          height: 'auto',
          width: Core.isAdmin() ? sizes.l5 : sizes.m5,
          maxWidth: 'calc(100vw - 2rem)'
        }}
      >
        <Once
          promise={async () => {
            updateState({
              employer: Obj(await readLoopbackRecord({
                collection: COLLECTION__EMPLOYERS,
                where: { id: employerId },
                fields: ['id', 'name'],
                limit: 1
              }))
            });
          }}
        />
        <SectionAtsSettings
          acl={YES(employer.id)}
          onChange={async (update) => {
            clearTimeout(mem.current.timeout);
            mem.current.timeout = setTimeout(async () => {
              Employer.cleanCache();
              await updateLoopbackRecord({
                collection: COLLECTION__EMPLOYERS,
                id: employerId,
                model: getEmployerModel({ extended: false }),
                record: update
              });
            }, 1000);
          }}
          employerId={employerId}
        />
      </Card>

    </Page>
  )
}
